
  import ClientCore from "../../../models/core/ClientCore";
  import ProjectCore from "../../../models/core/ProjectCore";
  import utils from "../../../utils/utils";
  import ProjectClientRow from "./ProjectClientRow.vue";

  export default {
    name: "ProjectsOverview",
    components: { ProjectClientRow },
    props: {
      projects: Array<ProjectCore>,
      mountedParent: Boolean
    },
    data() {
      return {
        text: {
          thereAreNoProjects: this.$t("thereAreNoProjects")
        }
      };
    },
    computed: {
      getClients(): ClientCore[] {
        // Collect unique client IDs, excluding the current user's clientId
        const uniqueClientIds = [
          ...new Set(
            this.projects
              .map(p => p.clientId)
              .filter(id => id !== this.getUser.clientId)
          )
        ];

        // Sort client IDs by client name
        return uniqueClientIds
          .map(id => this.getClientById(id))
          .sort((a, b) =>
            utils.compareWordsAlphabetically(a.getName, b.getName)
          );
      }
    },
    methods: {
      getClientProjects(clientId): ProjectCore[] {
        return this.projects.filter(p => p.getClientId == clientId);
      }
    }
  };
